

<!-- checkbox in table: https://xaksis.github.io/vue-good-table/guide/advanced/checkbox-table.html#configuration -->
<!-- input tag: https://github.com/matiastucci/vue-input-tag    /   https://tucci.me/vue-input-tag/-->

<template>
  <!-- modal information user -->
  <div class="modal fade" id="modal-select-user" tabindex="-1" style="font: normal 14px FontAwesome; font-size: inherit">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="text-align:center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h3 class="modal-title">{{$t('component_address_book.title')}}</h3>
        </div>
        <div class="modal-body">
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="form-group">
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-book">
                      <label>
                        <span
                          style="margin-left:5px;display:inline-block;"
                        >{{$t('component_address_book.title')}}:</span>
                      </label>
                    </i>
                  </div>
                  <select v-model="address_book_data.group_id" class="form-control" id="status">
                    <option
                      v-for="option in group_address_book"
                      v-bind:value="option.id"
                      :key="option.id"
                    >{{ option.text }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="form-group">
                <apartment-group-filter-component 
                  :btnDropDownTitle="btnDropDownTitle"
                  :isFilter="true"
                  :isHideNumberApartment="true"
                  :isHideManagementApartmentGroup="true"
                  @emitFilterApartmentInGroup="emitFilterApartmentInGroup"
                />
              </div>
            </div>
          </div>
          <!-- 
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-6 col-md-6 col-lg-6">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-user"></i>
                </span>
                <input
                  v-on:keyup.enter="onSearchUser"
                  type="text"
                  class="form-control"
                  :placeholder="$t('user.code')"
                  v-model="search.code"
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <input
                v-on:keyup.enter="onSearchUser"
                type="text"
                class="form-control"
                :placeholder="$t('user.fullname')"
                v-model="search.full_name"
              />
            </div>
          </div>
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-6 col-md-6 col-lg-6">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-mobile"></i>
                </span>
                <input
                  v-on:keyup.enter="onSearchUser"
                  type="text"
                  class="form-control"
                  :placeholder="$t('user.phone')"
                  v-model="search.phone"
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-envelope"></i>
                </span>
                <input
                  v-on:keyup.enter="onSearchUser"
                  type="text"
                  class="form-control"
                  :placeholder="$t('user.email')"
                  v-model="search.email"
                />
              </div>
            </div>
          </div>-->

          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <vue-good-table
                :columns="columns"
                :isLoading="isLoading" 
                :rows="rows"
                :select-options="{ enabled: true }"
                :search-options="{ enabled: true, placeholder: $t('component_address_book.search') }"
                @on-selected-rows-change="selectionChanged"
              >
                <template slot="loadingContent">
                  <div class="text-center text-danger my-2">{{$t('reportLiabilitiesReport.loading')}}</div>
                </template>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'fullname'">
                    <span>{{getFullName(props.row.first_name, props.row.last_name)}}</span> 
                  </span>
                  <span v-else-if="props.column.field == 'relationship'">
                    <span>{{ $t(getRelationship(props.row)) }}</span> 
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>

          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="form-group">
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-envelope-o">
                      <label>
                        <span
                          style="margin-left:5px;display:inline-block;"
                        >{{$t('component_address_book.to')}}:</span>
                      </label>
                    </i>
                  </div>

                  <vue-input-tag v-model="tagsEmail" validate="email"></vue-input-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-labeled pull-right"
            @click="doSelectEmail"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{$t('common.save')}}
          </button>

          <button
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >{{$t('common.close')}}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
  <!-- /.modal -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import constantsData from "../lib/constantsData";
// import moment from "moment";

// import vue-good-table
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
// vue-input-tag
import InputTag from "vue-input-tag";
import ApartmentGroupFilterComponent from "../views/Apartment/ApartmentGroupFilterComponent.vue"
import utils from '@/lib/utils';
import i18n from "../lang";
import Loading from "vue-loading-overlay";

export default {
  name: "SelectUserModal",
  props: {
    userId: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    customerId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data() {
    return {
      address_book_data: {
        group_id: 1
      },
      tagsEmail: [],
      group_address_book: [{ id: 1, text: "Public Address Book" }],
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },

      columns: [
        {
          label: this.$t('customer.apartment_code'),
          field: "apartment_code"
        },
        {
          label: this.$t('customer.fullname'),
          field: "fullname"
        },
        {
          label: this.$t('customer.email'),
          field: "email"
        },
        // {
        //   label: this.$t('customer.phone'),
        //   field: "phone"
        // },
        {
          label: this.$t('apartment.relationship'),
          field: "relationship"
        }
      ],
      rows: [],
      isLoading: false,
      griduserDataList: [],
      callBackFrom: "",
      btnDropDownTitle: 'apartment.apartmentGroupFilterTitle',
      apartmentGroupIdFilter: []
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([])
  },

  methods: {
    ...mapActions([
      "GET_CUSTOMER_LIST_FOR_MAIL_BOX"
    ]),

    setCallBackFunction(from) {
      this.callBackFrom = from
    },

    getFullName(firstname, lastname){
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    selectionChanged(selectedRows) {
      this.tagsEmail = selectedRows.selectedRows.map(function(item) {
        return item.email;
      });
    },
    doSelectEmail() {
      // send data to method doSelectEmail
      let data = {
        callBackFrom: this.callBackFrom,
        tagsEmail: this.tagsEmail
      }
      this.$emit("doSelectEmail", data);
      // hide modal
      $("#modal-select-user").modal("hide");
    },
    getRelationship: function(row) {
      if (row.isOwner) {
        return 'customer.headOfAHousehold'
      }
      if (row.isTenant) {
        return 'apartment.tenant'
      }
      return row.relationship_note
    },
    emitFilterApartmentInGroup: function(data) {
      this.apartmentGroupIdFilter = data
      this.getCustomerListForEmailBox()
    },
    getCustomerListForEmailBox: function() {
      let filter = {
        params: {
          apartmentGroupIdFilter: this.apartmentGroupIdFilter
        }
      }
      this.isLoading = true
      this.GET_CUSTOMER_LIST_FOR_MAIL_BOX(filter).then(
        function(res) {
          let data = res.data
          this.rows = data
          this.isLoading = false
          return this.griduserDataList;
        }.bind(this)
      ).catch(
        function(error) {
          this.isLoading = false
        }.bind(this)
      );
    }
  },
  mounted() {
    this.getCustomerListForEmailBox()
  },

  components: {
    "vue-good-table": VueGoodTable,
    "vue-input-tag": InputTag,
    ApartmentGroupFilterComponent,
    loading: Loading,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SelectUserModal.vue